// src/components/kuestion/solo/MocksChart.jsx
// Bars for the last few sittings. The pass line is drawn only when the
// sittings carry a threshold (v4 §6) — at the most recent one's value, since
// each sitting keeps the threshold in force when it started.
import React from 'react';
import { fmtDate } from '../shared/format';

export default function MocksChart({ sittings }) {
  const latestWithMark = [...sittings].reverse().find((s) => s.pass_percentage != null);
  const passMark = latestWithMark ? latestWithMark.pass_percentage : null;
  return (
    <div className="kqc-mocks">
      <div className="kqc-mocks__plot">
        {passMark != null && (
          <>
            <span className="kqc-mocks__line" style={{ bottom: `${passMark}%` }} aria-hidden="true" />
            <span className="kqc-mocks__pass" style={{ bottom: `calc(${passMark}% + 6px)` }} aria-hidden="true">Pass {passMark}%</span>
          </>
        )}
        {sittings.map((s) => {
          const pct = Math.max(0, Math.min(100, s.pct));
          const low = s.passed === false;
          return (
            <div className="kqc-mocks__col" key={s.id} title={`${s.exam_name} · ${Math.round(pct)}%`}>
              <div className={`kqc-mocks__val${low ? ' is-low' : ''}`}>{Math.round(pct)}%</div>
              <div className={`kqc-mocks__bar${low ? ' is-low' : ''}`} style={{ height: `${pct}%` }} />
            </div>
          );
        })}
      </div>
      <div className="kqc-mocks__dates">
        {sittings.map((s) => <div key={s.id}>{fmtDate(s.at)}</div>)}
      </div>
      <div className="kqc-small kqc-muted" style={{ marginTop: 10 }}>
        {passMark != null ? 'The red line is the pass mark of your latest paper. Each sitting is judged against the mark in force when it started.' : 'These papers carry no pass mark, so there is no line — just your scores.'}
      </div>
    </div>
  );
}
